
const globalConfig={
    apiBaseUrl: process.env.REACT_APP_API_ENDPOINT
}

export default globalConfig;